import styled from "styled-components";

export const SideBarWrapper = styled.div`
    border-radius: 4px;
    box-shadow: 0px 4px 8px rgba(34, 24, 24, 0.2);
    .avatar{
        .avatar_image{
            width: 120px;
            height: 120px;
            position: relative;
            display: flex;
            align-items: center;
            
            img{
                width: 100%;
                max-height: 100%;
                height: 100%;
                object-fit: contain;
                border-radius: 50%;
                background-color: white;
            }
            .edit_img{
                position: absolute;
                bottom: 0;
                right: -10px;
                border-radius: 50%;
            }
            .avatar_control{
                position: absolute;
                bottom: 0;
                right: -40px;
            }
        }
    }
    .input_avatar{
        height: 30px;
    }
    .sidebar_list{
        .list{
            list-style: none;
            .list_item{
                height: 50px;
                display: flex;
                align-items: center;
            }
        }
    }
`
